import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { RoutePending } from '@/shared/ui/route-pending';
import { openCaptureDialog } from '@/widgets/my-work/capture/capture-dialog-store';

import { parseCaptureShare, shareToCaptureText } from './-capture-share';

/**
 * `/capture?title=&text=&url=` — "Share to Projoint" (manifest `share_target`)
 * and the "Capture" app-icon shortcut (W4-E). Lands on My Work › Today and
 * opens Capture (the sheet on a phone, the dialog on a computer) prefilled
 * with what was shared. Capture is private by default: it goes to my
 * Personal inbox until I choose otherwise.
 */

/** One open per arrival (StrictMode runs effects twice in development). */
let handledKey: string | null = null;

function CaptureRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const text = shareToCaptureText(search);

  useEffect(() => {
    const key = `${window.history.state?.key ?? ''}|${text}`;
    if (handledKey === key) return;
    handledKey = key;
    void navigate({ to: '/my/work', search: { view: 'today' } as never, replace: true }).then(() => {
      openCaptureDialog(text ? { initialText: text } : {});
    });
  }, [navigate, text]);

  return <RoutePending />;
}

export const Route = createFileRoute('/capture')({
  validateSearch: parseCaptureShare,
  component: CaptureRoute,
});
